import * as React from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineDot from "@mui/lab/TimelineDot";
import SchoolIcon from '@mui/icons-material/School';
import Typography from "@mui/material/Typography";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import { pink } from "@mui/material/colors";

export default function CustomizedTimeline() {
  return (
    <Timeline position="alternate">
      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: "auto 0" }}
          align="right"
          variant="body1"
          color="text.primary"
        >
          <h3>Associate</h3>
          <h4>Nagpur, Maharashtra</h4>
          <p>Pertinent Healthcare & Business Solution</p>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot sx={{ bgcolor: " peru" }}>
            <WorkHistoryIcon sx={({ bgcolor: " white" }, { color: "white" })} />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: "12px", px: 2 }}>
          <Typography variant="h6" component="span"></Typography>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: "auto 0" }}
          variant="body1"
          color="text.primary"
        >
          <h3 className="vertical-timeline-element-title">
            Electrical Contractor
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            Nagpur, Maharashtra
          </h4>
          <p>MSEDCL</p>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot sx={{ bgcolor: " peru" }}>
            <WorkHistoryIcon sx={({ bgcolor: " white" }, { color: "white" })} />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: "12px", px: 2 }}>
          <Typography variant="h6" component="span">
          </Typography>
          <Typography></Typography>
        </TimelineContent>
      </TimelineItem>
      
      
      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: "auto 0" }}
          align="right"
          variant="body1"
          color="text.primary"
        >
          <h3>Associate</h3>
          <h4>Ahmedabad, Gujrat</h4>
          <p>T. Tech.</p>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot sx={{ bgcolor: " peru" }}>
            <WorkHistoryIcon sx={({ bgcolor: " white" }, { color: "white" })} />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: "12px", px: 2 }}>
          <Typography variant="h6" component="span"></Typography>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: "auto 0" }}
          variant="body1"
          color="text.primary"
        >
          <h3 className="vertical-timeline-element-title">
            Assistant Professor
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            Nagpur, Maharashtra
          </h4>
          <p>Priyadarshini College Of Engineering</p>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot sx={{ bgcolor: " peru" }}>
            <WorkHistoryIcon sx={({ bgcolor: " white" }, { color: "white" })} />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: "12px", px: 2 }}>
          <Typography variant="h6" component="span">
          </Typography>
          <Typography></Typography>
        </TimelineContent>
      </TimelineItem>


      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: "auto 0" }}
          align="right"
          variant="body1"
          color="text.primary"
        >
          <h3 className="vertical-timeline-element-title">M-Tech</h3>
     <h4 className="vertical-timeline-element-subtitle">Nagpur, Maharashtra</h4>
          <p>
     Yeshwantrao College Of Engineering
     </p>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot sx={{ bgcolor: " peru" }}>
            <SchoolIcon sx={({ bgcolor: " white" }, { color: "white" })} />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: "12px", px: 2 }}>
          <Typography variant="h6" component="span"></Typography>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: "auto 0" }}
          variant="body1"
          color="text.primary"
        >
          <h3 className="vertical-timeline-element-title">Bachelor of Engineering</h3>
     <h4 className="vertical-timeline-element-subtitle">Nagpur, Maharashtra</h4>
     <p>
       Anjuman College of Engineering
     </p>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot sx={{ bgcolor: " peru" }}>
            <SchoolIcon sx={({ bgcolor: " white" }, { color: "white" })} />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: "12px", px: 2 }}>
          <Typography variant="h6" component="span">
          </Typography>
          <Typography></Typography>
        </TimelineContent>
      </TimelineItem>


      
    </Timeline>
  );
}

// export default VerticalTimeliineComponent;
